document.addEventListener('DOMContentLoaded', function() {
  const toggles = document.querySelectorAll('.footer__accordion-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      if(window.innerWidth <= 768) {
        this.classList.toggle('active');
      }
    });
  });

  
  window.addEventListener('resize', function() {
    if(window.innerWidth > 768) {
      document.querySelectorAll('.footer__accordion-content').forEach(content => {
        content.style.maxHeight = null;
      });
      document.querySelectorAll('.footer__accordion-toggle').forEach(toggle => {
        toggle.classList.remove('active');
      });
    }
  });
});